import './sponsors.css';
import React from 'react';
import Scout from '../../img/Sponsors/Scout.png';
import Bright from '../../img/Sponsors/Bright.png';

export default class Sponsors extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            goldSponsors: [
                {
                    img: Scout,
                    alt: 'Scout',
                },
            ],
            platinumSponsors: [
                {
                    img: Bright,
                    alt: 'Bright',
                },
            ],
        };
      }

    renderSponsorsLogos(item, i) {
        return (
            <React.Fragment key={`sponsors_logo-${i}`}>
                {item.link && <a href={item.link} target='_blank' className='sponsors_logo_block'>
                    <img className='sponsors_logo' src={item.img} alt={item.alt} />
                </a>}
                {!item.link && <div className='sponsors_logo_block'>
                    <img className='sponsors_logo' src={item.img} alt={item.alt} />
                </div>}
            </React.Fragment>
        )
    }     

    render() {
        return (
            <div className='sponsors_wrap' id='sponsors'>
                <div className='container sponsors'>
                    <h3>Sponsors</h3>
                    <h2 className='sponsors_title'>Platinum</h2>
                    <div className='sponsors_logos'>
                        {this.state.platinumSponsors.map((item, i) => this.renderSponsorsLogos(item, i))}
                    </div>
                    <h2 className='sponsors_title'>Gold</h2>
                    <div className='sponsors_logos'>
                        {this.state.goldSponsors.map((item, i) => this.renderSponsorsLogos(item, i))}
                    </div>
                    {/* <h2 className='sponsors_title'>Silver Sponsors</h2>
                    <div className='sponsors_logos'>
                        {this.state.silverSponsors.map((item, i) => this.renderSponsorsLogos(item, i))}
                    </div>
                    <h2 className='sponsors_title'>Advocate Sponsors</h2>
                    <div className='sponsors_logos'>
                        {this.state.advocateSponsors.map((item, i) => this.renderSponsorsLogos(item, i))}
                    </div> */}
                </div>
            </div>
        )
    }
}